import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import Footer from "../footer";
import Navbar from "../navbar";
const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <ScrollToTop smooth width="20px" height="20px" />
    </>
  );
};

export default Layout;
